import { Button, Flex, FlexProps } from '@chakra-ui/react'
import { ReactNode } from 'react'

import { Icon } from '../Icon'

export interface IFilterBarProps extends Omit<FlexProps, 'onChange' | 'children'> {
  children: ReactNode
  /**
   * Liga o botão "Limpar filtros" no fim da barra. Voltar ao estado inicial é responsabilidade
   * da página: só ela sabe o que preservar (o `pageSize` escolhido, um status que já nasce filtrado).
   */
  onClear?: () => void
  /** Desabilita o "Limpar filtros" quando não há nada filtrado. Passe junto com `onClear`. */
  isDirty?: boolean
}

/**
 * Barra de filtros das listagens: um `Flex` com espaçamento e quebra de linha únicos para
 * todo o painel. As páginas declaram os campos, não o layout — nada de grid do Bootstrap,
 * `mr` campo a campo ou `mb` próprio.
 *
 * @example
 * <FilterBar onClear={clearFilters} isDirty={isDirty}>
 *   <FilterSearch value={filter.search} onChange={(search) => setFilter({ ...filter, search })} />
 *   <FilterSelect label="Status" value={filter.status} onChange={...} options={STATUS_OPTIONS} />
 * </FilterBar>
 */
export default function FilterBar({ children, onClear, isDirty = true, ...rest }: IFilterBarProps) {
  return (
    // `align="flex-end"`: os campos têm rótulo em cima, então é a base dos controles que
    // define a linha — é nela que o botão de limpar precisa se alinhar.
    <Flex as="section" aria-label="Filtros" gap="3" mb="5" align="flex-end" wrap="wrap" {...rest}>
      {children}
      {onClear && (
        <Button
          size="sm"
          variant="ghost"
          colorScheme="gray"
          flexShrink={0}
          leftIcon={<Icon name="lni lni-close" />}
          isDisabled={!isDirty}
          onClick={onClear}
        >
          Limpar filtros
        </Button>
      )}
    </Flex>
  )
}
